import ArrowLeft from '@/common/assets/icons/leftPoint.svg?react';
import Button from '@/common/components/base/button/Button.tsx';
import { css } from 'styled-system/css';
import { Center } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const CardEnterAction = ({ enterAction }: { enterAction: () => void }) => {
  return (
    <Center height={'26px'} textWrap={'nowrap'} width={'350px'}>
      <Button
        fontSize={'11px'}
        gap="5px"
        fullWidth
        variant="text"
        color="primary"
        onClick={enterAction}
      >
        <ArrowLeft
          className={css({
            position: 'relative',
            top: '2px',
          })}
          fill={token('colors.purple-2')}
        />
        ورود به صفحه
      </Button>
    </Center>
  );
};
export default CardEnterAction;
